import { useMemo, useState } from 'react'
import type { MarketCheckResponse, SavedStatusCheck } from '../types'
import MarketCheckModal from './MarketCheckModal'
import Tooltip from './Tooltip'

function labelForItem(item: SavedStatusCheck): string {
  const p = item.payload as any
  const iso = item.as_of || p?.now || item.created_at
  const dt = iso ? new Date(iso) : null
  const stamp = dt && !Number.isNaN(dt.getTime()) ? dt.toLocaleString() : 'Unknown time'
  return `Market snapshot • ${stamp}`
}

export default function SavedMarketSnapshots({ items }: { items: SavedStatusCheck[] }) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<MarketCheckResponse | null>(null)

  const marketItems = useMemo(() => items.filter((i) => (i.mode || '').toLowerCase() === 'markets'), [items])
  if (!marketItems.length) return null

  return (
    <>
      <div className="mt-3 border-t border-rule pt-3">
        <div className="text-xs text-muted tracking-wider font-semibold">SAVED MARKET SNAPSHOTS</div>
        <div className="mt-2 flex flex-wrap gap-2">
          {marketItems.slice(0, 6).map((item) => (
            <Tooltip key={item.status_check_id} content="Open this saved market snapshot.">
              <button
                type="button"
                className="rounded-full border border-rule bg-paper px-3 py-1.5 text-xs text-ink/90 hover:bg-white/40 transition max-w-full"
                title={item.headline_summary || ''}
                onClick={(e) => {
                  e.stopPropagation()
                  setData(item.payload as any)
                  setOpen(true)
                }}
              >
                <span className="truncate block max-w-[420px]">{labelForItem(item)}</span>
              </button>
            </Tooltip>
          ))}
        </div>
      </div>

      <MarketCheckModal open={open} onClose={() => setOpen(false)} data={data} />
    </>
  )
}


